"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import "./bold.css.js";
import "./extended-regular.css.js";
import "./regular.css.js";
const AudiFont = () => jsx(Fragment, {});
export {
  AudiFont
};
